import { render, staticRenderFns } from "./subsection.vue?vue&type=template&id=05140e45&"
import script from "./subsection.vue?vue&type=script&lang=js&"
export * from "./subsection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports